import { ApiUrls } from './api-urls';

export const environment = {
  tabTitle: 'GAP Dev',
  production: true,
  /** Each GAP API, through APIM: `<apim>/gap/<api>`. */
  apiUrls: {
    client: 'https://dev-apim-cus-common.azure-api.net/gap/client',
    env: 'https://dev-apim-cus-common.azure-api.net/gap/env',
    partner: 'https://dev-apim-cus-common.azure-api.net/gap/partner',
    alert: 'https://dev-apim-cus-common.azure-api.net/gap/alert',
    envserv: 'https://dev-apim-cus-common.azure-api.net/gap/envserv',
    ident: 'https://dev-apim-cus-common.azure-api.net/gap/ident',
    ltp: 'https://dev-apim-cus-common.azure-api.net/gap/ltp',
    // The feature-flag service: APIM serves it at its own root, not under /gap
    fflag: 'https://dev-apim-cus-common.azure-api.net/fflag/api',
    // The authorization service, which gives the user's level on GAP: APIM serves it at its root too
    authz: 'https://dev-apim-cus-common.azure-api.net/authz/api'
  } satisfies ApiUrls,
  keycloak: {
    url: 'https://auth-dev.gainsapps.com',
    realm: 'GAINSystems',
    clientId: 'gap-frontend'
  }
};
